import type { FocusEvent } from 'react'

/**
 * Simply scrolls the event target into view when focused
 * @param ev
 */
export const scrollOnFocus = (ev: FocusEvent) => {
	ev.target.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
